export default __webpack_public_path__ + "static/media/Helm of the Blood Drinker (nm).d26b9f9c.jpg";